import { meta, loader, default as DocsPage } from "~/routes/docs.$";

function SplatPage() {
  return <DocsPage />;
}

export default SplatPage;
export { meta, loader };
